import React from 'react';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const EnrollmentModalHeader = ({
  showAddLicense,
  setShowAddLicense,
  licenses,
  showEditLicense
}) => {
  const getAddLicenseTitle = () => {
    if (showEditLicense) {
      return 'Edit license';
    }
    return 'Add new license';
  };

  return (
    <div className="flex w-full items-center justify-between">
      {showAddLicense ? (
        licenses.length > 0 ? (
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setShowAddLicense(false)}
              className="flex items-center gap-1 text-sm font-500 text-neutral-800 hover:text-neutral-900">
              <Icon icon="arrow-left-linear" size={16} />
              Enroll to e-Prescribe
            </button>
            <span className="text-neutral-400">/</span>
            <span className="text-sm font-600 text-neutral-800">{getAddLicenseTitle()}</span>
          </div>
        ) : (
          <h6 className="text-sm font-600 leading-4 text-neutral-800">{getAddLicenseTitle()}</h6>
        )
      ) : (
        <div className="flex w-full items-center justify-between">
          <h6 className="text-sm font-600 leading-4 text-neutral-800">Enroll to e-Prescribe</h6>
          <Button
            text="Add new license"
            icon="add-square-mono"
            iconColor="neutral-700"
            variant="tertiary"
            size="small"
            className="!border-none"
            textClassName="!text-neutral-700"
            onClick={() => setShowAddLicense(true)}
          />
        </div>
      )}
    </div>
  );
};

export default EnrollmentModalHeader;
